import React from 'react';

import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from '@mui/icons-material';
import { capitalize } from '@mui/material';

import { Segment } from '../../../appTypes';

import styles from '../Map.module.css';

export function CardinalArrow({ direction }: { direction: string }) {
  const attrs = { height: '16px', width: '16px' };
  const lookup = {
    east: <ArrowForward {...attrs} />, // eslint-disable-line react/jsx-props-no-spreading
    west: <ArrowBack {...attrs} />, // eslint-disable-line react/jsx-props-no-spreading
    north: <ArrowUpward {...attrs} />, // eslint-disable-line react/jsx-props-no-spreading
    south: <ArrowDownward {...attrs} />, // eslint-disable-line react/jsx-props-no-spreading
  };
  return (
    <span className={styles.cardinal_arrow_container}>{lookup[direction]}</span>
  );
}

export function SegmentNameAndDirectionalityInfo({
  cardinal,
  hwc,
  name,
}: {
  cardinal: string;
  hwc: string;
  name: string;
}) {
  let nice_name = name;
  const nice_hwc = capitalize((hwc || '').replace(/_/g, ' '));
  if (nice_name.split('_').length > 2) {
    // Reliable but not perfect way of telling a segment is named with the ID
    nice_name = nice_hwc;
  }
  return (
    <>
      <h1>{nice_name}</h1>
      <p>
        {cardinal && (
          <>
            <CardinalArrow direction={cardinal} />
            {capitalize(cardinal)}
            {'bound - '}
          </>
        )}
        {nice_hwc}
      </p>
    </>
  );
}

export function MapSegmentTooltip({
  segment,
}: {
  segment: Segment | undefined;
}) {
  if (!segment) return null;

  return (
    <div className={styles.map_tooltip_container} data-hide-in-export>
      <SegmentNameAndDirectionalityInfo
        cardinal={segment.properties.cardinal_dir}
        hwc={segment.properties.hwc}
        name={segment.properties.name || 'Unknown'}
      />
    </div>
  );
}
